<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div><i class="fa fa-suitcase mr-05"></i> Fiche pro</div>
      <div
        v-if="workplaceInfo.updatedAt || workplaceInfo.createdAt"
        class="text-muted"
      >
        Mis à jour le
        {{ formatDateTime(workplaceInfo.updatedAt || workplaceInfo.createdAt) }}
      </div>
    </div>
    <div class="card-block">
      <Tabs v-model="activeTab">
        <Tab header="Informations">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Secteur d'activité</label>
                <v-select
                  v-if="hasWritePermission"
                  v-model="form.industry"
                  :options="industries"
                  @input="
                    (e) => editWorkplaceInfo({ name: 'industry', value: e })
                  "
                ></v-select>
                <em v-else class="d-block">{{
                  workplaceInfo.industry || "Non renseigné"
                }}</em>
              </div>

              <div class="form-group">
                <label>Nom de l'entreprise</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.companyName"
                  type="text"
                  @change="
                    (e) => editWorkplaceInfo({ name: 'companyName', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.companyName || "Non renseigné"
                }}</em>
              </div>

              <div class="form-group">
                <label>Poste</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.job"
                  type="text"
                  @change="(e) => editWorkplaceInfo({ name: 'job', value: e })"
                />
                <em v-else class="d-block">{{
                  workplaceInfo.job || "Non renseigné"
                }}</em>
              </div>

              <div class="form-group">
                <label>Poste pénible</label>
                <el-switch
                  v-if="hasWritePermission"
                  v-model="form.isPainfulJob"
                  active-text="Oui"
                  inactive-text="Non"
                  class="d-block"
                  @change="
                    (e) => editWorkplaceInfo({ name: 'isPainfulJob', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.isPainfulJob ? "Oui" : "Non"
                }}</em>
              </div>

              <div class="form-group">
                <label>Poste sédentaire</label>
                <el-switch
                  v-if="hasWritePermission"
                  v-model="form.isSedentaryJob"
                  active-text="Oui"
                  inactive-text="Non"
                  class="d-block"
                  @change="
                    (e) =>
                      editWorkplaceInfo({ name: 'isSedentaryJob', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.isSedentaryJob ? "Oui" : "Non"
                }}</em>
              </div>

              <div class="form-group">
                <label>Mode de déplacement</label>
                <v-select
                  v-if="hasWritePermission"
                  v-model="form.travelMode"
                  :options="travelModeOptions"
                  @input="
                    (e) => editWorkplaceInfo({ name: 'travelMode', value: e })
                  "
                ></v-select>
                <em v-else class="d-block">{{
                  workplaceInfo.travelMode || "Non renseigné"
                }}</em>
              </div>

              <div class="form-group">
                <label>Temps de trajet par jour</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.travelTime"
                  type="text"
                  @change="
                    (e) => editWorkplaceInfo({ name: 'travelTime', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.travelTime || "Non renseigné"
                }}</em>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Remarques</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.notes"
                  type="textarea"
                  :rows="10"
                  @change="
                    (e) => editWorkplaceInfo({ name: 'notes', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.notes || "Non renseigné"
                }}</em>
              </div>
            </div>
          </div>
        </Tab>

        <Tab header="QVCT">
          <div class="row">
            <div class="col-sm-6">
              <div class="h6">Référent QVCT</div>
              <hr />
              <div class="form-group">
                <label>Nom</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctReferent.name"
                  type="text"
                  @change="
                    (e) =>
                      editWorkplaceInfo({ name: 'qvctReferent.name', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctReferent.name || "Non renseigné"
                }}</em>
              </div>
              <div class="form-group">
                <label>Poste</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctReferent.job"
                  type="text"
                  @change="
                    (e) =>
                      editWorkplaceInfo({ name: 'qvctReferent.job', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctReferent.job || "Non renseigné"
                }}</em>
              </div>
              <div class="form-group">
                <label>Email</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctReferent.email"
                  type="email"
                  @change="
                    (e) =>
                      editWorkplaceInfo({
                        name: 'qvctReferent.email',
                        value: e,
                      })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctReferent.email || "Non renseigné"
                }}</em>
              </div>
              <div class="form-group">
                <label>Téléphone</label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctReferent.phone"
                  type="tel"
                  @change="
                    (e) =>
                      editWorkplaceInfo({
                        name: 'qvctReferent.phone',
                        value: e,
                      })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctReferent.phone || "Non renseigné"
                }}</em>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label
                  >Actions ou démarches QVCT (semaine de la QVCT, safety
                  days..)</label
                >
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctProcesses"
                  type="textarea"
                  :rows="6"
                  @change="
                    (e) =>
                      editWorkplaceInfo({ name: 'qvctProcesses', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctProcesses || "Non renseigné"
                }}</em>
              </div>
              <div class="form-group">
                <label
                  >Avantages pour les salariés (activités intra ou extra
                  entreprise...)
                </label>
                <el-input
                  v-if="hasWritePermission"
                  v-model="form.qvctBenefits"
                  type="textarea"
                  :rows="6"
                  @change="
                    (e) => editWorkplaceInfo({ name: 'qvctBenefits', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  workplaceInfo.qvctBenefits || "Non renseigné"
                }}</em>
              </div>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-start mt-1" style="gap: 1rem">
            <div v-if="workplaceInfo.id">
              <button
                :disabled="!hasWritePermission || sendingLinkedinEmail"
                class="btn btn-primary"
                @click="sendLinkedinEmail"
              >
                <i class="fa fa-linkedin mr-05"></i> Envoyer l'email
                d'invitation
              </button>
              <small
                v-if="workplaceInfo.linkedinEmailSentAt"
                class="form-text text-primary"
              >
                Dernier envoi:
                {{ formatDateTime(workplaceInfo.linkedinEmailSentAt) }}
              </small>
            </div>

            <div>
              <button
                v-if="hasWritePermission"
                class="btn btn-success"
                :disabled="qvctReferentIncomplete || sendingLeadToB2bCommercial"
                @click="sendLeadToB2bCommercial"
              >
                <i class="fa fa-plus mr-05"></i> Lead B2B
              </button>
              <small
                v-if="qvctReferentIncomplete"
                class="form-text text-danger"
                >Les informations du référent QVCT sont incomplètes</small
              >
              <small
                v-if="workplaceInfo.leadSentToB2bCommercialAt"
                class="form-text text-success"
              >
                Lead envoyé le
                {{ formatDateTime(workplaceInfo.leadSentToB2bCommercialAt) }}
              </small>
            </div>
          </div>
        </Tab>

        <Tab header="Feedback">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Commercial B2B</label>
                <v-select
                  v-if="hasWritePermission"
                  v-model="form.b2bCommercialEmail"
                  :options="b2bCommercials"
                  :reduce="({ value }) => value"
                  @input="
                    (e) =>
                      editWorkplaceInfo({
                        name: 'b2bCommercialEmail',
                        value: e,
                      })
                  "
                />
                <em v-else-if="currentB2bCommercial" class="d-block">{{
                  currentB2bCommercial.label
                }}</em>
                <em v-else class="d-block"> Non renseigné </em>
              </div>

            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Statut du lead B2B</label>
                <v-select
                  v-if="hasWritePermission"
                  v-model="form.leadStatus"
                  :options="leadStatusOptions"
                  :reduce="({ value }) => value"
                  @input="
                    (e) => editWorkplaceInfo({ name: 'leadStatus', value: e })
                  "
                />
                <em v-else class="d-block">{{
                  leadStatusOptions.find(
                    (option) => option.value === workplaceInfo.leadStatus,
                  )?.label || "Non renseigné"
                }}</em>
              </div>

              <div
                v-if="showContactedAt"
                class="d-flex flex-wrap"
                style="gap: 0.5rem"
              >
                <dt style="flex: 2; min-width: 100px">Contacté le</dt>
                <dd style="flex: 3">
                  <Datepicker
                    v-if="hasWritePermission"
                    v-model="form.contactedAt"
                    format="dd.MM.yyyy"
                    language="fr"
                    input-class="form-control"
                    @input="
                      (e) =>
                        editWorkplaceInfo({ name: 'contactedAt', value: e })
                    "
                  />
                  <em v-else class="d-block">{{
                    workplaceInfo.contactedAt
                      ? formatDateTime(workplaceInfo.contactedAt)
                      : "Non renseigné"
                  }}</em>
                </dd>
              </div>

              <div
                v-if="showAuditAt"
                class="d-flex flex-wrap"
                style="gap: 0.5rem"
              >
                <dt style="flex: 2; min-width: 100px">Audit réalisé le</dt>
                <dd style="flex: 3">
                  <Datepicker
                    v-if="hasWritePermission"
                    v-model="form.auditAt"
                    format="dd.MM.yyyy"
                    language="fr"
                    input-class="form-control"
                    @input="
                      (e) => editWorkplaceInfo({ name: 'auditAt', value: e })
                    "
                  />
                  <em v-else class="d-block">{{
                    workplaceInfo.auditAt
                      ? formatDateTime(workplaceInfo.auditAt)
                      : "Non renseigné"
                  }}</em>
                </dd>
              </div>

              <div
                v-if="showSaleAt"
                class="d-flex flex-wrap"
                style="gap: 0.5rem"
              >
                <dt style="flex: 2; min-width: 100px">Vente réalisée le</dt>
                <dd style="flex: 3">
                  <Datepicker
                    v-if="hasWritePermission"
                    v-model="form.saleAt"
                    format="dd.MM.yyyy"
                    language="fr"
                    input-class="form-control"
                    @input="
                      (e) => editWorkplaceInfo({ name: 'saleAt', value: e })
                    "
                  />
                  <em v-else class="d-block">{{
                    workplaceInfo.saleAt
                      ? formatDateTime(workplaceInfo.saleAt)
                      : "Non renseigné"
                  }}</em>
                </dd>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Tabs,
    Tab,
    Datepicker,
  },

  props: {
    client: {
      type: Object,
      required: true,
    },

    commercials: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeTab: 0,
      workplaceInfo: {},
      form: {
        b2bCommercialEmail: undefined,
        companyName: undefined,
        industry: undefined,
        job: undefined,
        isPainfulJob: false,
        isSedentaryJob: false,
        travelMode: undefined,
        travelTime: undefined,
        notes: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        qvctProcesses: undefined,
        qvctBenefits: undefined,
        qvctReferent: {
          name: undefined,
          job: undefined,
          email: undefined,
          phone: undefined,
        },
        linkedinEmailSentAt: undefined,
        leadSentToB2bCommercialAt: undefined,
        leadStatus: undefined, // 'contacted', 'no_response', 'lost_pre_audit', 'audit', 'lost_post_audit', 'sale'
        contactedAt: undefined,
        auditAt: undefined,
        saleAt: undefined,
      },
      travelModeOptions: [
        "Voiture",
        "Transports en commun",
        "Vélo",
        "Marche",
        "Télétravail",
        "Autre",
      ],
      leadStatusOptions: [
        { label: "Non contacté", value: undefined },
        { label: "Contacté", value: "contacted" },
        { label: "Pas de réponse", value: "no_response" },
        { label: "Perdu (refusé l'Audit)", value: "lost_pre_audit" },
        { label: "Audit réalisé", value: "audit" },
        { label: "Perdu Post Audit", value: "lost_post_audit" },
        { label: "Vente réalisée", value: "sale" },
      ],
      sendingLinkedinEmail: false,
      sendingLeadToB2bCommercial: false,
    };
  },

  computed: {
    ...mapGetters({
      industries: "getIndustries",
    }),

    hasWritePermission() {
      return this.hasPermission(this.$store.state.user, "CLIENTS_WRITE");
    },

    b2bCommercials() {
      return this.commercials.filter((c) => c.isB2B);
    },

    currentB2bCommercial() {
      return this.commercials.find(
        (c) => c.email === this.workplaceInfo.b2bCommercialEmail,
      );
    },

    showContactedAt() {
      return [
        "contacted",
        "no_response",
        "lost_pre_audit",
        "audit",
        "lost_post_audit",
        "sale",
      ].includes(this.workplaceInfo.leadStatus);
    },

    showAuditAt() {
      return [
        "audit",
        "lost_post_audit",
        "sale",
      ].includes(this.workplaceInfo.leadStatus);
    },

    showSaleAt() {
      return this.workplaceInfo.leadStatus === "sale";
    },

    qvctReferentIncomplete() {
      return (
        !this.workplaceInfo.qvctReferent ||
        Object.values(this.workplaceInfo.qvctReferent).length < 4 ||
        Object.values(this.workplaceInfo.qvctReferent).some((value) => !value)
      );
    },
  },

  mounted() {
    this.setWorkplaceInfoAndForm(this.client.workplaceInfo || {});
  },

  methods: {
    setWorkplaceInfoAndForm(workplaceInfo) {
      this.workplaceInfo = {
        ...this.workplaceInfo,
        ...workplaceInfo,
        qvctReferent: {
          ...this.workplaceInfo.qvctReferent,
          ...workplaceInfo.qvctReferent,
        },
      };

      this.form = {
        ...this.form,
        ...workplaceInfo,
        qvctReferent: {
          ...this.form.qvctReferent,
          ...workplaceInfo.qvctReferent,
        },
      };
    },

    editWorkplaceInfo({ name, value }) {
      if (this.workplaceInfo.id) {
        this.updateWorkplaceInfo({ name, value });
      } else {
        this.createWorkplaceInfo();
      }
    },

    async createWorkplaceInfo() {
      try {
        const { data } = await this.$api.post("/workplaces", {
          ...this.workplaceInfo,
          clientEmail: this.client.email,
        });

        this.setWorkplaceInfoAndForm(data);
      } catch (e) {
        this.$errorToast("Impossible de créer la fiche pro");

        this.resetForm();
      }
    },

    async updateWorkplaceInfo({ name, value }) {
      try {
        const data = {
          clientEmail: this.client.email,
        };

        if (name.includes(".")) {
          const [parentKey, childKey] = name.split(".");

          data[parentKey] = {
            [childKey]: value,
          };
        } else {
          data[name] = value;
        }

        const { data: updatedData } = await this.$api.put(
          `/workplaces/${this.workplaceInfo.id}`,
          data,
        );

        this.setWorkplaceInfoAndForm(updatedData);
      } catch (e) {
        this.$errorToast("Impossible de mettre à jour la fiche pro");

        this.form[name] = this.client.workplaceInfo[name] || undefined;
      }
    },

    async sendLinkedinEmail() {
      try {
        this.sendingLinkedinEmail = true;

        await this.$api.post(
          `/workplaces/${this.workplaceInfo.id}/linkedin-email`,
          {
            clientEmail: this.client.email,
          },
        );

        this.setWorkplaceInfoAndForm({
          linkedinEmailSentAt: new Date(),
        });
      } catch (e) {
        this.$errorToast("Impossible d'envoyer l'email d'invitation LinkedIn");
      } finally {
        this.sendingLinkedinEmail = false;
      }
    },

    async sendLeadToB2bCommercial() {
      try {
        this.sendingLeadToB2bCommercial = true;

        await this.$api.post(
          `/workplaces/${this.workplaceInfo.id}/send-to-b2b-commercial`,
          {
            clientEmail: this.client.email,
          },
        );

        this.setWorkplaceInfoAndForm({
          leadSentToB2bCommercialAt: new Date(),
        });
      } catch (e) {
        this.$errorToast("Impossible d'envoyer le lead au commercial B2B");
      } finally {
        this.sendingLeadToB2bCommercial = false;
      }
    },

    resetForm() {
      this.form = {
        b2bCommercialEmail: undefined,
        companyName: undefined,
        industry: undefined,
        job: undefined,
        isPainfulJob: false,
        isSedentaryJob: false,
        travelMode: undefined,
        travelTime: undefined,
        notes: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        qvctProcesses: undefined,
        qvctBenefits: undefined,
        qvctReferent: {
          name: undefined,
          job: undefined,
          email: undefined,
          phone: undefined,
        },
        linkedinEmailSentAt: undefined,
        leadSentToB2bCommercialAt: undefined,
        leadStatus: undefined,
        contactedAt: undefined,
        auditAt: undefined,
        saleAt: undefined,
      };
    },
  },
};
</script>
